import { Button, Modal, ModalActions, ModalContent, ModalTitle, modalClasses } from "@kaltura/ds-react-components";
import { translate, translatePlural } from "@kaltura/mediaspace-shared-utils";
import styled from "@emotion/styled";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

const StyledModal = styled(Modal)({
    [`& .${modalClasses.paper}`]: {
        maxWidth: 584,
    },
});

interface BulkDeleteConfirmationModalProps {
    open: boolean;
    processing: boolean;
    selectedCount: number;
    onClose: () => void;
    onConfirm: () => void;
}

export const BulkDeleteConfirmationModal = ({
    open,
    processing,
    selectedCount,
    onClose,
    onConfirm,
}: BulkDeleteConfirmationModalProps) => {
    const sendButtonAnalytics = useButtonAnalytics();

    const handleDelete = () => {
        sendButtonAnalytics(
            "Confirm bulk delete items",
            ButtonClickAnalyticsType.DELETE,
            undefined,
            "recycle bin",
            "Modal - Recycle bin - Permanently delete"
        );
        onConfirm();
    };

    const handleCancel = () => {
        sendButtonAnalytics(
            "Cancel bulk delete items",
            ButtonClickAnalyticsType.CLOSE,
            undefined,
            "recycle bin",
            "Modal - Recycle bin - Permanently delete"
        );
        onClose();
    };

    return (
        <StyledModal open={open} onClose={onClose} maxWidth={false}>
            <ModalTitle>{translate("Permanently delete")}</ModalTitle>
            <ModalContent>
                {translatePlural(
                    "Are you sure you want to permanently delete %1 item? Please note that this action cannot be undone.",
                    "Are you sure you want to permanently delete %1 items? Please note that this action cannot be undone.",
                    [selectedCount]
                )}
            </ModalContent>
            <ModalActions>
                <Button variant="borderless" color="secondary" onClick={handleCancel}>
                    {translate("Cancel")}
                </Button>
                <Button color="danger" onClick={handleDelete} loading={processing} disabled={processing}>
                    {translate("Delete")}
                </Button>
            </ModalActions>
        </StyledModal>
    );
};
